export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

export const cognitoConfig = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID
};

export const auth0Config = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN
};

export const mapConfig = process.env.REACT_APP_MAP_MAPBOX;

export const googleAnalyticsConfig = process.env.REACT_APP_GA_MEASUREMENT_ID;

// export const isProduction = true;
export const isProduction = true;

// valor false si isProduction es true
// export const isLockerV2 = true;
export const isLockerV2 = true;

export const backendURL = process.env.REACT_APP_BACKEND_URL;

export const lockerEmbebidoUrl = process.env.REACT_APP_LOCKER_EMBEBIDO;
// export const backendURL = process.env.REACT_APP_BACKEND_URL_SANDBOX;
// export const backendURL = process.env.REACT_APP_BACKEND_URL_PATITO;

export const backendURLSandbox = process.env.REACT_APP_BACKEND_URL_SANDBOX;
export const backendURLLocker = process.env.REACT_APP_BACKEND_URL_LOCKER;

export const mercadopagoPK = process.env.REACT_APP_MERCADOPAGO_PK;

export const locker = process.env.REACT_APP_LOCKER_T_URL;

export const mapskey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const notikey = process.env.REACT_APP_NOTI_PUBLIC_KEY;

export const terminal_id_recargas = process.env.REACT_APP_TERMINAL_ID_RECARGAS;
export const terminal_id_servicios = process.env.REACT_APP_TERMINAL_ID_SERVICIOS;
